import { render } from "./GalleryWrapper.vue?vue&type=template&id=5dee5a50"
import script from "./GalleryWrapper.vue?vue&type=script&lang=js"
export * from "./GalleryWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__